import icon from './arrow-icon.txt';

export default {
    props: {
        direction: {
            type: String,
            default: 'bottom',
        }
    },
    render (h) {
        return h('span', {
            class: `modal-arrow-icon modal-arrow-icon--${this.direction}`,
            domProps: {
                innerHTML: icon,
            }
        })
    }
}
